export const UNMATCHED_ROUTE = 'unmatched';
export const DEFAULT_OWNER = 'team-unowned';

let template: string | undefined;
let owner = DEFAULT_OWNER;

export function routeTemplate(route: string | undefined) {
  if (!route || route === '/*' || route === '*') {
    return UNMATCHED_ROUTE;
  }
  return route;
}

export function rememberRoute(route: string | undefined, nextOwner?: string) {
  template = routeTemplate(route);
  owner = nextOwner ?? DEFAULT_OWNER;
}

export function currentPageAttributes(): Record<string, string> {
  if (!template) {
    return {};
  }
  return {
    'page_view.path_template': template,
    'page_view.owner': owner,
  };
}
